import KanbanCard, { STATUS_COLORS } from './KanbanCard';
import { STATUS_OPTIONS } from './ApplicationForm';
import { useTranslation } from 'react-i18next';

function KanbanBoard({ applications, selectedAppId, onSelect, onStatusChange, onDelete, onAddNote }) {
    const { t } = useTranslation();
    const getByStatus = (status) =>
        applications.filter(app => app.status === status);

    return (
        <div className="kanban-board">
            {STATUS_OPTIONS.map(status => (
                <div key={status} className="kanban-column">
                    <div className="kanban-header" style={{ borderColor: STATUS_COLORS[status] }}>
                        <span>{t(`internships.${status}`)}</span>
                        <span className="kanban-count">{getByStatus(status).length}</span>
                    </div>
                    <div className="kanban-cards">
                        {getByStatus(status).map(app => (
                            <KanbanCard
                                key={app.id}
                                app={app}
                                isSelected={selectedAppId === app.id}
                                onSelect={onSelect}
                                onStatusChange={onStatusChange}
                                onDelete={onDelete}
                                onAddNote={onAddNote}
                            />
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default KanbanBoard;